module.exports = __webpack_public_path__ + "static/img/mustardSeed.12297be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posters/mustardSeed.jpg
// module id = 7
// module chunks = 0